import * as React from "react"
import { DropdownType, ZoneType } from "@/types"
import { useQueries } from "@tanstack/react-query"

import { getBooksZone, getZoneDropdown } from "@/lib/api/billing"
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

import { Input } from "./ui/input"

type ZoneBookType = {
  id: number
}

type BooksDropdownType = {
  id: number
  name: string
  zone_id: number
  zone: string
  description: string
}

export function ZoneBookFilter({
  setBooks = () => {},
  books,
  zones,
  setZones = () => {},
}: {
  setBooks?: React.Dispatch<React.SetStateAction<number[]>>
  books?: number[]
  zones?: number[]
  setZones?: React.Dispatch<React.SetStateAction<number[]>>
}) {
  //const [selectedZones, setSelectedZones] = React.useState<number[]>([]);
  const [selectedBooks, setSelectedBooks] = React.useState<number[]>([])

  const queryConfigs = [
    {
      queryKey: ["zones"],
      queryFn: getZoneDropdown,
    },
    ...(zones && zones.length > 0
      ? zones.map((zoneId) => ({
          queryKey: ["booksZone", zoneId],
          queryFn: () => getBooksZone(zoneId),
        }))
      : []),
  ]

  const results = useQueries({
    queries: queryConfigs,
  })

  // Zones and books data
  const zonesData = results[0]?.data || []
  const booksData = results.slice(1).map((res) => res.data || [])

  // Group books by zone_id
  const booksByZone = booksData.reduce(
    (acc, books) => {
      books.forEach((book: BooksDropdownType) => {
        if (!acc[book.zone_id]) acc[book.zone_id] = []
        acc[book.zone_id].push(book)
      })
      return acc
    },
    {} as Record<number, BooksDropdownType[]>,
  )

  const handleZoneCheckboxChange = (id: number) => {
    /*setSelectedZones((prev) =>
            prev.includes(id) ? prev.filter((zoneId) => zoneId !== id) : [...prev, id]
        );*/
    setZones((prev) =>
      prev.includes(id)
        ? prev.filter((zoneId) => zoneId !== id)
        : [...prev, id],
    )
  }

  //Individual book selection
  const handleBookSelect = (bookId: number) => {
    setSelectedBooks((prev) =>
      prev.includes(bookId)
        ? prev.filter((id) => id !== bookId)
        : [...prev, bookId],
    )

    setBooks((prev) =>
      prev.includes(bookId)
        ? prev.filter((id) => id !== bookId)
        : [...prev, bookId],
    )
  }

  return (
    <>
      {zones && (
        <>
          <span className="font-semibold">Zones</span>
          <DropdownMenuSeparator className="bg-gray-300 px-2" />
          <div className="my-1 flex flex-col gap-2">
            {zonesData.map((zone: DropdownType) => {
              return (
                <div key={zone.id} className="flex flex-col">
                  <label className="flex items-center space-x-2">
                    <Input
                      type="checkbox"
                      value={zone.id}
                      checked={zones.includes(zone.id)}
                      onChange={() => handleZoneCheckboxChange(zone.id)}
                      className="h-4 w-4"
                    />
                    <span onClick={() => handleZoneCheckboxChange(zone.id)}>
                      {zone.label}
                    </span>
                  </label>

                  {/* Display books for the selected zone */}

                  {books &&
                    zones.includes(zone.id) &&
                    booksByZone[zone.id]?.length > 0 && (
                      <div className="ml-6 flex flex-col gap-2">
                        {booksByZone[zone.id].map((book: DropdownType) => (
                          <label
                            key={book.id}
                            className="flex items-center space-x-2"
                          >
                            <Input
                              type="checkbox"
                              className="h-4 w-4"
                              checked={selectedBooks.includes(book.id)}
                              onChange={() => handleBookSelect(book.id)}
                            />
                            <span>{book.label}</span>
                          </label>
                        ))}
                      </div>
                    )}
                </div>
              )
            })}
          </div>
        </>
      )}
    </>
  )
}
